module.exports = __webpack_public_path__ + "static/img/blues.2a926e70.png";